@if (showCloseButton) {
  <button
    mat-icon-button
    class="close-button celo-dialog-close celo-dialog-close--floating"
    aria-label="Close"
    (click)="handleClose()"
  >
    <mat-icon>close</mat-icon>
  </button>
}

<app-start-trial-cta
  [plan]="dialogData.trialData?.subscriptionTier ?? null"
  [isStartTrialLoading]="isStartTrialLoading"
  [upgradeUrl]="upgradeUrl"
  (startTrial)="handleStartTrial()"
  (ignoreTrial)="handleIgnoreTrial()"
></app-start-trial-cta>
